// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-239EC";
export { _1 as "__esModule", _2 as "header" }
export default { "__esModule": _1, "header": _2 }
